(function () {
  function initReadingForm(root) {
    if (!root || root.dataset.wwReadingFormReady === 'true') return;
    root.dataset.wwReadingFormReady = 'true';

    var form = root.querySelector('[data-ww-reading-form-el]');
    var modal = root.querySelector('[data-ww-rf-modal]');

if (modal) {
  var rootStyles = window.getComputedStyle(root);
  var varsToCopy = [
    '--ww-rf-primary-button-color',
    '--ww-rf-primary-button-text-color',
    '--ww-rf-primary-button-hover-color',
    '--ww-rf-primary-button-hover-text-color',
    '--ww-rf-secondary-button-color',
    '--ww-rf-secondary-button-text-color',
    '--ww-rf-secondary-button-hover-line-color',
    '--ww-rf-secondary-button-hover-text-color',
    '--ww-rf-button-font-desktop',
    '--ww-rf-button-font-mobile'
  ];

  varsToCopy.forEach(function (varName) {
    modal.style.setProperty(varName, rootStyles.getPropertyValue(varName));
  });

  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
}

    var openBtn = root.querySelector('[data-ww-rf-open-confirm]');
var closeBtns = modal ? modal.querySelectorAll('[data-ww-rf-close-confirm]') : [];
var confirmBtn = modal ? modal.querySelector('[data-ww-rf-confirm-checkout]') : null;

    var timeRow = root.querySelector('[data-ww-rf-time-row]');
    var timeUnknown = root.querySelector('[data-ww-rf-time-unknown]');
    var hour = root.querySelector('[data-ww-rf-hour]');
    var minute = root.querySelector('[data-ww-rf-minute]');
    var ampm = root.querySelector('[data-ww-rf-ampm]');

    function getValue(selector) {
      var el = root.querySelector(selector);
      return el ? el.value.trim() : '';
    }

function setText(selector, value) {
  var el = root.querySelector(selector) || (modal ? modal.querySelector(selector) : null);
  if (el) el.textContent = value || '-';
}

    function updateTimeDisabledState() {
      var isUnknown = timeUnknown && timeUnknown.checked;

      if (timeRow) {
        timeRow.classList.toggle('is-disabled', isUnknown);
      }

      [hour, minute, ampm].forEach(function (select) {
        if (!select) return;
        select.disabled = isUnknown;
        if (isUnknown) select.value = '';
      });
    }

    function getBirthDateText() {
      var day = getValue('[data-ww-rf-day]');
      var month = getValue('[data-ww-rf-month]');
      var year = getValue('[data-ww-rf-year]');

      if (!day || !month || !year) return '-';
      return day + ' ' + month + ' ' + year;
    }

    function getBirthTimeText() {
      if (timeUnknown && timeUnknown.checked) return 'Unknown';

      var h = hour ? hour.value : '';
      var m = minute ? minute.value : '';
      var a = ampm ? ampm.value : '';

      if (!h && !m && !a) return 'Not provided';
      if (!h || !m || !a) return 'Incomplete';

      return h + ':' + m + ' ' + a;
    }

function limitQuestionWords() {
  var textarea = root.querySelector('[data-ww-rf-question]');
  if (!textarea) return;

  var text = textarea.value.trim();
  if (!text) return;

  var words = text.match(/\S+/g) || [];

  if (words.length <= 250) return;

  textarea.value = words.slice(0, 250).join(' ');
}

    function populateSummary() {
      setText('[data-ww-rf-summary-name]', getValue('[data-ww-rf-name]'));
      setText('[data-ww-rf-summary-email]', getValue('[data-ww-rf-email]'));
      setText('[data-ww-rf-summary-dob]', getBirthDateText());
      setText('[data-ww-rf-summary-time]', getBirthTimeText());
      setText('[data-ww-rf-summary-question]', getValue('[data-ww-rf-question]'));
    }

    function openModal() {
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      populateSummary();

      if (modal) {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
    }

    function closeModal() {
      if (modal) {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
      }
    }


function continueToCheckout() {
  if (!form.checkValidity()) {
    closeModal();
    form.reportValidity();
    return;
  }

  if (confirmBtn) {
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Processing...';
  }

  var data = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: data
  })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart add failed');
      window.location.href = '/cart';
    })
    .catch(function() {
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Confirm & Continue to Checkout';
      }
      alert('Something went wrong. Please try again.');
    });
}




var questionTextarea = root.querySelector('[data-ww-rf-question]');

if (questionTextarea) {
  questionTextarea.addEventListener('input', limitQuestionWords);
}

    if (timeUnknown) {
      timeUnknown.addEventListener('change', updateTimeDisabledState);
      updateTimeDisabledState();
    }

    if (openBtn) {
      openBtn.addEventListener('click', openModal);
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', continueToCheckout);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initAllReadingForms() {
    document.querySelectorAll('[data-ww-reading-form]').forEach(initReadingForm);
  }

  document.addEventListener('DOMContentLoaded', initAllReadingForms);
  document.addEventListener('shopify:section:load', initAllReadingForms);
})();